import { useEffect } from 'react';
import { useHistory } from '@react-router';
import { useMcpPreviewForceSsr } from '@shared/context/mcpPreviewForceSsr';
import { PREVIEW_CAP_PARAM, stripPreviewCapParam } from '@shared/utils/previewCapParam';

/** On the MCP preview path, normalize the browser URL once on mount: strip the spent `pv` cap so Back works. See MCP_PREVIEW.md#pv-cap. */
export const McpPreviewUrlNormalizer: React.FC = () => {
  const forceSsr = useMcpPreviewForceSsr();
  const history = useHistory();

  useEffect(() => {
    if (!forceSsr || typeof window === 'undefined') return;
    const { pathname, search, hash } = window.location;
    const params = new URLSearchParams(search);
    if (!params.has(PREVIEW_CAP_PARAM) && params.get('mcpPreview') === '1') return; // already clean
    stripPreviewCapParam(params);
    params.set('mcpPreview', '1');
    history.replace({ pathname, search: `?${params.toString()}`, hash });
    // Run once on mount (normalize the initial entry).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
